import CONTROL_EXPLANATIONS from '../controlExplanations';
import NIST171_EXPLANATIONS from './nist171Explanations';
import SOC2_EXPLANATIONS from './soc2Explanations';
import ISO27001_EXPLANATIONS from './iso27001Explanations';
import HIPAA_EXPLANATIONS from './hipaaExplanations';
import NIST_CSF_EXPLANATIONS from './nistCsfExplanations';
import PCI_DSS_EXPLANATIONS from './pciDssExplanations';
import FEDRAMP_EXPLANATIONS from './fedRampExplanations';

// CMMC uses CONTROL_EXPLANATIONS from the root data file
const CMMC_EXPLANATIONS = CONTROL_EXPLANATIONS;

export {
  CMMC_EXPLANATIONS,
  NIST171_EXPLANATIONS,
  SOC2_EXPLANATIONS,
  ISO27001_EXPLANATIONS,
  HIPAA_EXPLANATIONS,
  NIST_CSF_EXPLANATIONS,
  PCI_DSS_EXPLANATIONS,
  FEDRAMP_EXPLANATIONS,
};

export const EXPLANATIONS = {
  cmmc: CMMC_EXPLANATIONS,
  nist_171: NIST171_EXPLANATIONS,
  soc2: SOC2_EXPLANATIONS,
  iso27001: ISO27001_EXPLANATIONS,
  hipaa: HIPAA_EXPLANATIONS,
  nist_csf: NIST_CSF_EXPLANATIONS,
  pci_dss: PCI_DSS_EXPLANATIONS,
  fedramp: FEDRAMP_EXPLANATIONS,
};

/**
 * Returns the explanation object for a given framework + control ID.
 * Always returns an object — never null.
 * If no explanation exists, returns a placeholder with isPlaceholder: true.
 */
export function getControlExplanation(framework, controlId) {
  const map = EXPLANATIONS[framework];
  if (map && map[controlId]) {
    return map[controlId];
  }
  return {
    isPlaceholder: true,
    plain_english: 'No detailed explanation is available for this control yet.',
    example: '',
    evidence_tips: [],
    common_mistakes: '',
    nist_reference: controlId,
  };
}
